import { jsx as _jsx } from "react/jsx-runtime";
import { SkapaChoiceItem } from '@inter-ikea-guida/skapa';
import { StyledGridChoice } from '../style/component-styles/ChoiceStyles';
export const GuidaGridChoice = ({ preselectedChoice, dataTestId, options, onOptionClick, ariaLabel }) => {
    return (_jsx(StyledGridChoice, { size: 'medium', preselectedIndex: preselectedChoice, subtle: true, "data-testid": dataTestId, "aria-label": ariaLabel, children: options.map(opt => {
            return (_jsx(SkapaChoiceItem, { id: opt.id, title: opt.title, onClick: e => onOptionClick(e), image: opt.image }, opt.id));
        }) }));
};
//# sourceMappingURL=GuidaGridChoice.js.map